











import { Component, Inject, Vue, Ref, Prop } from "vue-property-decorator";
import Hammerjs from "hammerjs";

@Component
export default class NavigationPager extends Vue {
    @Inject("closeCurrentView") readonly closeCurrentView!: () => void;
    @Ref("pager") pager!: HTMLElement;

    @Prop({type: Boolean}) fullFlowLayout!: boolean;

    private navigationPagerHeight = 46; //px

    previousHash = window.location.hash;
    private touch!: HammerManager;

    private get style() {
        return {
            "height": this.navigationPagerHeight + "px",
        }
    }

    mounted() {
        if (this.touch) {
            this.destroyed();
        }
        this.touch = new Hammerjs(this.pager);
        this.touch.on("swiperight", () => {
            this.closeCurrentView();
        });
        this.$emit("set-element-height", this.navigationPagerHeight);
    }

    destroyed() {
        this.touch.destroy();
    }
}
